import { api } from "../../../api/api";
import {
  IImportBillPaymentList,
  IImportBulkPaymentBill,
} from "./importBulkPaymentBill.types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIError } from "../../../constants/types";
import { endPoints } from "../../../constants/endPoints";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const fetchImportBulkPaymentBill = createAsyncThunk<
  {
    data: IImportBulkPaymentBill[];
  },
  {
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    status: string;
    date: IDataTableV2DateState["dates"];
    searchValue: IDatatableV2AdvancedSearchFilter;
    type: string;
  },
  { rejectValue: APIError }
>(
  "importBulkPaymentBill/fetchImportBulkPaymentBill",
  async (
    { pageNumber, rowsInPerPage, limit, status, date, searchValue, type },
    { rejectWithValue }
  ) => {
    try {
      let finalUrl = `${endPoints.importBulkPaymentBill.fetchImportBulkPaymentBill}?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&pageLimit=${limit}&from_date=${date.fromDate}&to_date=${date.toDate}&type=${type}`;
      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += `&status=${status}`;
      }

      const res = await api.get(finalUrl);
      const data: IImportBulkPaymentBill[] = res.data.data;
      return { data };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  }
);

export const fetchImportBulkBillPaymentList = createAsyncThunk<
  IImportBillPaymentList[],
  string,
  { rejectValue: APIError }
>(
  "importBulkPaymentBill/fetchImportBulkBillPaymentList",
  async (invoiceCode: string, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `${endPoints.importBulkPaymentBill.fetchImportBulkBillPaymentList}?invoice_payment_code=${invoiceCode}`
      );
      const data: IImportBillPaymentList[] = res.data.data;
      return data;
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  }
);
